/**
 * @todo Удалить хук если эксп не заапрувится
 * @description Данный функционал появился в задаче CD-138414, будет удалён в задаче CD-138473
 */
import { ca } from '@cian/analytics';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAbGroupSelector } from '../../../../hooks/selectors/useAbGroupSelector';
import { useAgentSelector } from '../../../../hooks/selectors/useAgentSelector';
import { useOfferSelector } from '../../../../hooks/selectors/useOfferSelector';
import { selectUser } from '../../../../selectors';
import { getPage } from '../../../../utils/tracking/getPage';
import { getUser } from '../../../../utils/tracking/getUser';
import { getProducts } from '../../../../utils/tracking/get_products';

type Action = 'Click_auth_pact_trap' | 'Click_download_pact';

export function useTrackContractTemplateBlock() {
  const offer = useOfferSelector();
  const agent = useAgentSelector();
  const user = useSelector(selectUser);
  const abGroup = useAbGroupSelector();

  const products = getProducts({ agent, offer, kpId: null });

  return useCallback<(action: Action) => void>(
    action =>
      ca('eventSite', {
        name: 'oldevent',
        action,
        category: 'Card',
        page: getPage(agent, offer, null),
        products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
        user: getUser(user, abGroup),
      }),
    [abGroup, agent, offer, products, user],
  );
}
